import { ReactNode } from 'react';

// Generic section wrapper with consistent spacing/border for dashboard areas

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="border border-evat-gold/30 bg-black/50 rounded p-4">
      <h3 className="font-orbitron mb-3 text-lg text-evat-gold">{title}</h3>
      {children}
    </section>
  );
}

export default Section;









